module.exports = "<div class=\"form-box\" [style.display]=\"disabled?'none':'block'\">\n  <div class=\"YesNo\">\n    {{prompt}}<span *ngIf=\"required\">*</span><span *ngIf=\"!!tooltip\" [tooltip]=\"tooltip\" class=\"QuestionTooltip\">🛈</span>\n  </div>\n  <ng-template #checkmarkContainer></ng-template>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/questionnaire/elements/checkmark.with.items.component.html
// module id = ../../../../../src/app/pages/questionnaire/elements/checkmark.with.items.component.html
// module chunks = main